<template>
  <div v-if="modelValue && modelValue.ElementId">
    <MostaSelect
      v-model="widthValue"
      class="q-mb-xs"
      :label="$t('element_width')"
      :options="widthOptions"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
import { generalStore } from '@/store/general';
import { BaseItemTypes } from '@/components/dnd/ItemTypes';
import MostaSelect from '@/components/common/MostaSelect.vue';

@Component({
  name: 'ReportElementSettingsPanel',
  components: { MostaSelect }
})
export default class ReportElementSettingsPanel extends Vue {
  // v-model
  @Prop({ default: {} as any })
  modelValue: any | undefined

  genstore: any | undefined = undefined
  widthValue: any = undefined

  created() {
    this.genstore = generalStore()
  }

  @Watch('modelValue')
  mounted() {
    this.widthValue = this.widthOptions.find((el: any) => el.value === this.modelValue.ElementScale)
  }

  // width function
  get widthOptions() {
    return [{
      label: this.$t('screen_width'),
      value: 0
    }, {
      label: this.$t('half_screen_width'),
      value: 1
    }, {
      label: this.$t('quarter_screen_width'),
      value: 2
    }]
  }

  @Watch('widthValue')
  updateElementScale(arg: any) {
    if (arg.value === this.modelValue.ElementScale) { return }
    if (this.widthValue && this.modelValue && this.modelValue.ElementId && 
    this.modelValue.elType !== BaseItemTypes.BREAK && this.genstore) {
      this.genstore.updateElementScale({
        id: this.modelValue.ElementId,
        NewScale: this.widthValue.value,
        type: this.modelValue.elType
      })
    }
  }
}
</script>

<style lang="scss">
</style>